export default __webpack_public_path__ + "static/equilibre_icon_message-ff1cd0d5dcf31a8f640c5f75363b00a1.png";